(function (root) {
  function createCore(THREE, A, makeCanvas) {
    var TW = 2.048, TH = 1.024, Z0 = 0.874, Z1 = 0.920, D = 0.516, P = 0.0338;
    var PLAN = { 'GZ-002': 1, 'GZ-003': 1, 'GZ-004': 1, 'GZ-005': 1, 'GZ-006': 1, 'GZ-007': 1, 'GZ-009': 1, 'GZ-013': 1 };
    function lin(hex) { return new THREE.Color(hex).convertSRGBToLinear(); }

    // ---- matériaux partagés
    var M = {};
    function makeMaterials(woodImage) {
      var wood = new THREE.Texture(woodImage || woodCanvas());
      wood.wrapS = wood.wrapT = THREE.RepeatWrapping; wood.encoding = THREE.sRGBEncoding; wood.anisotropy = 8; wood.needsUpdate = true;
      M.hevea = new THREE.MeshStandardMaterial({ map: wood, roughness: 0.55, metalness: 0 });
      M.acier = new THREE.MeshStandardMaterial({ color: lin('#c3c5c7'), metalness: 0.85, roughness: 0.38 });
      // panneau perfor\u00e9 : trous de 12 mm dessin\u00e9s en clair (visibles m\u00eame de loin sur mobile)
      var cv = makeCanvas(64, 64), ctx = cv.getContext('2d');
      ctx.fillStyle = '#606060'; ctx.fillRect(0, 0, 64, 64);
      var h = Math.round(64 * 0.012 / P); ctx.fillStyle = '#e4e4e2'; ctx.fillRect(32 - h / 2, 32 - h / 2, h, h);
      var peg = new THREE.CanvasTexture(cv); peg.wrapS = peg.wrapT = THREE.RepeatWrapping; peg.anisotropy = 8; peg.encoding = THREE.sRGBEncoding;
      M.peg = new THREE.MeshStandardMaterial({ color: 0xffffff, map: peg, side: THREE.DoubleSide, roughness: 0.55 });
      M.structure = new THREE.MeshStandardMaterial({ color: lin('#2a2a2b'), roughness: 0.55 });
      M.facade = new THREE.MeshStandardMaterial({ color: lin('#606060'), roughness: 0.45 });
      M.alu = new THREE.MeshStandardMaterial({ color: lin('#e4e4e4'), metalness: 1, roughness: 0.28 });
      M.floor = new THREE.MeshStandardMaterial({ color: lin('#8c8c8a'), roughness: 0.9 });
      M.wall = new THREE.MeshStandardMaterial({ color: lin('#dcdcd9'), roughness: 0.95 });
      M.ghost = new THREE.LineBasicMaterial({ color: 0xffffff });
      ['hevea','peg','structure','facade','floor','wall'].forEach(function (k) { M[k].envMapIntensity = 0.6; });
    }

    // ---- préparation des modèles importés
    var models = {};
    function pegUV(o) {
      // coordonnees de texture recalculees face par face (1 unite = 1 trou de 33,8 mm) : la compression les avait supprimees.
      // Un meme objet peut contenir plusieurs panneaux (ex. le L du module d'angle) : on oriente d'apres la normale de chaque sommet.
      var g = o.geometry, pos = g.attributes.position, nor = g.attributes.normal, v = new THREE.Vector3(), n = new THREE.Vector3();
      var nm = new THREE.Matrix3().getNormalMatrix(o.matrixWorld), uv = new Float32Array(pos.count * 2);
      for (var i = 0; i < pos.count; i++) {
        v.fromBufferAttribute(pos, i).applyMatrix4(o.matrixWorld);
        var faceX = false; if (nor) { n.fromBufferAttribute(nor, i).applyMatrix3(nm); faceX = Math.abs(n.x) > Math.abs(n.z); }
        uv[i * 2] = (faceX ? v.z : v.x) / P; uv[i * 2 + 1] = v.y / P;
      }
      g.setAttribute('uv', new THREE.BufferAttribute(uv, 2));
    }
    function prepare(scene) {
      scene.updateMatrixWorld(true);
      scene.traverse(function (o) {
        if (!o.isMesh) return;
        o.castShadow = true; o.receiveShadow = true;
        var m = o.material, n = (m && m.name) || '';
        if (m && !m.__env) { m.envMapIntensity = (m.metalness > 0.5) ? 1.0 : 0.6; m.__env = true; }
        if (n === 'plan_travail') { o.userData.plan = true; }
        else if (n === 'panneau_perfore') { if (!o.geometry.attributes.uv) pegUV(o); o.material = M.peg; o.castShadow = false; }
        else if (n.indexOf('灯条') === 0) { m.emissive = new THREE.Color(1, 1, 1); m.emissiveIntensity = 0.9; }
      });
      return scene;
    }
    function loadAll(onProgress) {
      var loader = new THREE.GLTFLoader(), codes = Object.keys(A.glb), done = 0;
      return Promise.all(codes.map(function (code) {
        return new Promise(function (res) {
          var src = A.glb[code];
          function ok(g) { models[code] = prepare(g.scene); done++; if (onProgress) onProgress(done / codes.length); res(); }
          function ko() { done++; if (onProgress) onProgress(done / codes.length); res(); }
          if (/^(https?:)?\/\//.test(src) || src.charAt(0) === '/') { loader.load(src, ok, undefined, ko); return; }
          var bin = atob(src), u = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
          loader.parse(u.buffer, '', ok, ko);
        });
      }));
    }
    function has(code) { return code === 'GZ-013' || !!models[code]; }

    // ---- texture d'hévéa générée (lamelles aboutées, 1 px = 2 mm)
    function woodCanvas() {
      var W = 1024, H = 512, cv = makeCanvas(W, H), ctx = cv.getContext('2d'), img = ctx.createImageData(W, H), d = img.data;
      var seed = 7; function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
      var v0 = 0;
      while (v0 < H) {
        var w = Math.min(H - v0, 18 + Math.floor(rnd() * 5)); if (H - v0 - w < 12) w = H - v0;
        var cuts = [], pos = Math.floor(rnd() * W); cuts.push(pos);
        while (true) { var L = 125 + Math.floor(rnd() * 325); if (pos + L > cuts[0] + W - 100) break; pos += L; cuts.push(pos); }
        var tints = cuts.map(function () { var k = 1 + (rnd() - 0.5) * 0.16; return [214 * k * (1 + (rnd() - .5) * .02), 152 * k * (1 + (rnd() - .5) * .02), 92 * k * (1 + (rnd() - .5) * .02)]; });
        var waves = []; for (var q = 0; q < 5; q++) waves.push([0.15 + rnd() * 0.9, 1 + Math.floor(rnd() * 3), 0.005 + rnd() * 0.012, rnd() * 6, 1 + rnd() * 3, rnd() * 6]);
        for (var v = v0; v < v0 + w; v++) {
          var zig = Math.abs(((v - v0) % 8) - 4) * 1.2;
          for (var u = 0; u < W; u++) {
            var p = ((u - zig) % W + W) % W, idx = cuts.length - 1, best = 1e9;
            for (var c = 0; c < cuts.length; c++) {
              var rel = ((p - cuts[c]) % W + W) % W; if (rel < best) { best = rel; idx = c; }
              var dist = Math.min(Math.abs(p - (cuts[c] % W)), W - Math.abs(p - (cuts[c] % W))); if (dist < 1) best = best; 
            }
            var g = 0;
            for (var k = 0; k < waves.length; k++) { var wv = waves[k]; g += wv[2] * Math.sin(2 * Math.PI * wv[0] * (v + wv[4] * Math.sin(2 * Math.PI * wv[1] * u / W + wv[5])) + wv[3]); }
            var t = tints[idx], dark = (best < 1 || v === v0) ? 0.82 : 1, o = (v * W + u) * 4;
            d[o] = Math.min(255, t[0] * (1 + g) * dark); d[o + 1] = Math.min(255, t[1] * (1 + g) * dark); d[o + 2] = Math.min(255, t[2] * (1 + g) * dark); d[o + 3] = 255;
          }
        }
        v0 += w;
      }
      ctx.putImageData(img, 0, 0); return cv;
    }

    // ---- GZ-013 (établi ouvert) : partie haute d'un module fournisseur (caisson, LED, panneau perforé) + piétement acier
    var top013 = null;
    function upperOf(code) {
      var src = models[code].clone(true); src.updateMatrixWorld(true);
      var v = new THREE.Vector3();
      src.traverse(function (o) {
        if (!o.isMesh) return;
        var g = o.geometry.clone(), pos = g.attributes.position, idx = g.index ? g.index.array : null, n = idx ? idx.length : pos.count, keep = [];
        for (var t = 0; t < n; t += 3) {
          var ok = true;
          for (var k = 0; k < 3; k++) { var vi = idx ? idx[t + k] : t + k; v.fromBufferAttribute(pos, vi).applyMatrix4(o.matrixWorld); if (v.y < Z0 - 0.004) { ok = false; break; } }
          if (ok) { keep.push(idx ? idx[t] : t, idx ? idx[t + 1] : t + 1, idx ? idx[t + 2] : t + 2); }
        }
        g.setIndex(keep); o.geometry = g; if (!keep.length) o.visible = false;
      });
      return src;
    }
    function makeGZ013() {
      var g = new THREE.Group();
      if (models['GZ-005']) {
        if (!top013) top013 = upperOf('GZ-005');
        g.add(top013.clone(true));
      }
      var fb = models['GZ-005'] ? new THREE.Box3().setFromObject(models['GZ-005']) : new THREE.Box3(new THREE.Vector3(-0.34, 0, -0.26), new THREE.Vector3(0.34, 2.03, 0.26));
      var x0 = fb.min.x, x1 = fb.max.x, zb = fb.min.z, cx = (x0 + x1) / 2, s = 0.05;
      function box(w, h, d, x, y, z, mat, rz) { var m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mat); m.position.set(x, y, z); if (rz) m.rotation.z = rz; m.castShadow = m.receiveShadow = true; g.add(m); return m; }
      var zf = zb + D - 0.03 - s / 2, zr = zb + 0.03 + s / 2, xl = x0 + 0.02 + s / 2, xr = x1 - 0.02 - s / 2;
      [[xl, zf], [xr, zf], [xl, zr], [xr, zr]].forEach(function (p) { box(s, Z0 - 0.005, s, p[0], (Z0 - 0.005) / 2, p[1], M.structure); });
      var span = xr - xl - s;
      // ceinture sous le plan de travail uniquement (pas de traverse basse)
      [zf, zr].forEach(function (z) { box(span, 0.06, 0.04, cx, Z0 - 0.035, z, M.structure); });
      [xl, xr].forEach(function (x) { box(0.04, 0.06, zf - zr - s, x, Z0 - 0.035, (zf + zr) / 2, M.structure); });
      return g;
    }

    // ---- plan de travail continu (UV en mètres, fil du bois dans la longueur)
    function slab(x0, x1, z0, z1, along) {
      var geo = new THREE.BoxGeometry(x1 - x0, Z1 - Z0, z1 - z0);
      geo.translate((x0 + x1) / 2, (Z0 + Z1) / 2, (z0 + z1) / 2);
      var pos = geo.attributes.position, nor = geo.attributes.normal, uv = geo.attributes.uv;
      for (var i = 0; i < pos.count; i++) {
        var x = pos.getX(i), y = pos.getY(i), z = pos.getZ(i), ny = nor.getY(i);
        var a = along === 'x' ? x : z, c = along === 'x' ? z : x;
        if (Math.abs(ny) < 0.5) { if (Math.abs(along === 'x' ? nor.getX(i) : nor.getZ(i)) > 0.5) { a = c; } c = y * 3; }
        uv.setXY(i, a / TW, c / TH);
      }
      var m = new THREE.Mesh(geo, M.hevea); m.userData.plan = true; m.castShadow = m.receiveShadow = true; return m;
    }

    function segments(list, along) {
      var segs = [], cur = null;
      list.forEach(function (it) {
        if (!PLAN[it.code]) { cur = null; return; }
        if (cur && Math.abs(cur[1] - it.a0) < 0.002) cur[1] = it.a1; else { cur = [it.a0, it.a1]; segs.push(cur); }
      });
      return segs;
    }

    // ---- construction de la composition
    function build(seq, planMode) {
      var group = new THREE.Group(), placed = [], ci = seq.indexOf('GZ-010');
      var w1 = ci >= 0 ? seq.slice(0, ci) : seq.slice(), w2 = ci >= 0 ? seq.slice(ci + 1) : [];
      seq = seq.filter(has); ci = seq.indexOf('GZ-010'); w1 = ci >= 0 ? seq.slice(0, ci) : seq.slice(); w2 = ci >= 0 ? seq.slice(ci + 1) : [];
      function inst(code) {
        if (code === 'GZ-013') return makeGZ013();
        var o = models[code].clone(true);
        if (code !== 'GZ-009') return o;
        // GZ-009 : modèle fournisseur 78 mm plus bas (sans pieds) -> on le remonte et on ajoute un socle
        var g = new THREE.Group(), lift = 0.078; o.position.y = lift; g.add(o); o.updateMatrixWorld(true);
        var b = new THREE.Box3().setFromObject(o);
        var socle = new THREE.Mesh(new THREE.BoxGeometry(b.max.x - b.min.x - 0.02, lift, Math.max(0.2, b.max.z - b.min.z - 0.05)), M.structure);
        socle.position.set((b.min.x + b.max.x) / 2, lift / 2, b.min.z + Math.max(0.2, b.max.z - b.min.z - 0.05) / 2);
        socle.castShadow = socle.receiveShadow = true; g.add(socle);
        return g;
      }
      var x = 0, list1 = [];
      w1.forEach(function (code, i) {
        var o = inst(code); o.updateMatrixWorld(true);
        var b = new THREE.Box3().setFromObject(o);
        o.position.set(x - b.min.x, 0, -b.min.z); group.add(o);
        var a0 = x; x += (b.max.x - b.min.x);
        list1.push({ code: code, a0: a0, a1: x }); placed.push({ code: code, obj: o, idx: i });
      });
      var Xc = x, list2 = [], arm1 = 0, arm2 = 0;
      if (ci >= 0) {
        var meta = A.meta['GZ-010']; arm1 = meta.arm1; arm2 = meta.arm2;
        Xc = x + arm1;
        var c = inst('GZ-010'); c.position.set(Xc, 0, 0); group.add(c); placed.push({ code: 'GZ-010', obj: c, idx: ci });
        var z = arm2;
        w2.forEach(function (code, j) {
          var o = inst(code); o.rotation.y = -Math.PI / 2; o.updateMatrixWorld(true);
          var b = new THREE.Box3().setFromObject(o);
          o.position.set(Xc - b.max.x, 0, z - b.min.z); group.add(o);
          var a0 = z; z += (b.max.z - b.min.z);
          list2.push({ code: code, a0: a0, a1: z }); placed.push({ code: code, obj: o, idx: ci + 1 + j });
        });
      }
      segments(list1, 'x').forEach(function (s) { group.add(slab(s[0], s[1], 0, D, 'x')); });
      segments(list2, 'z').forEach(function (s) { group.add(slab(Xc - D, Xc, s[0], s[1], 'z')); });
      applyPlan(group, planMode);
      var L1 = ci >= 0 ? Xc : x, L2 = list2.length ? list2[list2.length - 1].a1 : (ci >= 0 ? arm2 : 0);
      return { group: group, placed: placed, corner: ci >= 0, Xc: Xc, L1: L1, L2: L2 };
    }
    function applyPlan(group, mode) {
      var mat = mode === 'acier' ? M.acier : M.hevea;
      group.traverse(function (o) { if (o.isMesh && o.userData.plan) o.material = mat; });
    }
    return { has: has, makeMaterials: makeMaterials, loadAll: loadAll, build: build, applyPlan: applyPlan, M: M, models: models, D: D };
  }
  root.createStahlCore = createCore;
})(typeof window !== 'undefined' ? window : globalThis);
